import React, { PureComponent, useContext } from 'react';
import Styles from './snackbar.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Snackbar = ({ snackbarActive, setSnackbarActive, message, icon, link, spin }) => {

    React.useEffect(() => {
        if (snackbarActive === true) {
            setTimeout(() => {
                setSnackbarActive(false);
            }, 5000);
        }
    }, [snackbarActive]);

    return (
        <div
            className={snackbarActive
                ? [Styles.snackbar, Styles.fadeIn].join(" ")
                : [Styles.snackbar, Styles.fadeOut].join(' ')}
        >
            <div className="flex items-center gap-x-2">
                {spin ? (
                    <div className="rounded-full h-6 w-6 bg-transparent flex items-center justify-center">
                        <FontAwesomeIcon icon={['fas', icon.length == 0 ? 'fa-check' : icon]} className="text-black text-md" spin={spin} />
                    </div>
                ) : (
                    <div className="rounded-full h-6 w-6 bg-black flex items-center justify-center">
                        <FontAwesomeIcon icon={['fas', icon.length == 0 ? 'fa-check' : icon]} className="text-white text-md" />
                    </div>
                )}
                <div className="ml-2 mt-1">
                    <p className="text-md font-semibold text-black truncate">{message}</p>
                    <div className="flex items-center">
                        <a href={link} target="_blank" className="text-sm font-semibold text-main cursor-pointer">View on Block Explorer</a>
                        <FontAwesomeIcon icon={['fas', 'fa-arrow-up-right-from-square']} className="text-main text-xs ml-2" />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Snackbar;
